import React from 'react';
import Header from './modules/Header';
import HeroSection from './components/landing/hero-section';
import ProblemSection from './components/landing/problem-section';
import SolutionSection from './components/landing/solution-section';
import AIGenesSection from './components/landing/ai-genes-section';
import PulseGeneShowcase from './components/landing/pulsegene-showcase';
import DeploymentSection from './components/landing/deployment-section';
import ShowcaseSection from './components/landing/showcase-section';
import UseCaseSection from './components/landing/use-case-section';
import WhyNowSection from './components/landing/why-now-section';
import TeamSection from './components/landing/team-section';
import Footer from './components/landing/footer';
import './styles/reset.css';
import './styles/globals.css';
import './styles/header.css';
import './styles/problemBox.css';
import './styles/solutionBox.css';
import './styles/useCaseBox.css';
import './styles/styles.css';
import CalendlyWidget from './modules/CalendlyWidget';
import CookieConsent from "./modules/CookieConsent";

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white">
      <Header />
      <main className="pt-20">
        <HeroSection />
        <ProblemSection />
        {/* <SolutionSection solutions={[]} /> */}
        <AIGenesSection />
        {/* <PulseGeneShowcase /> */}
        <DeploymentSection />
        <ShowcaseSection />
        <UseCaseSection cases={[]} />
        <WhyNowSection />
        <TeamSection members={[]} />
        <CalendlyWidget url="https://calendly.com/bobbieshrivastav/solvraysdemo?back=1&month=2025-01" />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}

export default App;
